import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  desc?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex items-end justify-between gap-4">
      <div>
        {eyebrow && (
          <span className="mb-2 inline-block rounded bg-accent-100 px-2 py-0.5 text-xs font-medium text-accent-800">
            {eyebrow}
          </span>
        )}
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {desc && <p className="mt-1 text-sm text-foreground-500">{desc}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-700 transition-colors hover:text-accent-600"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}